// extracted by mini-css-extract-plugin
module.exports = {"supportContainer":"supportPage_supportContainer__3wWb6","supportBody":"supportPage_supportBody__26MTn"};